import { userDate } from 'owa-datetime';

/**
 * Parse a date value in string and return a dislay date object for Txp event
 *
 * @param value ISO date in string format
 */
export default function parseTxpEventDate(value: string) {
    try {
        return userDate(value);
    } catch {
        // Keep original behavior of returning null if parsing fails.
        return null;
    }
}
